// Runtime configuration for backend URL
// This file ensures the correct URL is used based on the environment

let cachedUrl = null;

export function getBackendUrl() {
  // Check hostname at runtime (not build time)  
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;

    // If hosted on ngrok, use same-origin so API calls hit the ngrok backend
    if (hostname.endsWith('.ngrok-free.app') || hostname.endsWith('.ngrok.app') || hostname.endsWith('.ngrok.io')) {
      return window.location.origin;
    }

    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      // npm run dev:local: the dev server passes API calls on to the backend (vue.config.js)
      if (process.env.VUE_APP_API_SAME_ORIGIN === '1') return window.location.origin;
      const port = process.env.VUE_APP_BACKEND_PORT || '3000';
      const currentPort = window.location.port;

      // If we're actually being served by the backend, use same-origin.
      if (currentPort && currentPort === port) {
        return window.location.origin;
      }
      return `http://localhost:${port}`;
    }

    // Railway preview deployments — use same-origin so test frontend hits test backend
    if (hostname.endsWith('.up.railway.app')) {
      return window.location.origin;
    }
  }
  // Production URL
  return 'https://cc360.rampslogistics.com';
}

// Initialize URL on first access
function initUrl() {
  if (cachedUrl === null) {
    cachedUrl = getBackendUrl();
  }
  return cachedUrl;
}

// Export url as a getter - will be evaluated when module loads in browser
export const url = initUrl();

